import React from 'react'
import { Typography, Spacer } from '@telus-uds/components-web'

export type PepOffersSectionProps = {
  headerLabel?: string
  deviceOffers?: React.ReactNode
}

const PepOffersSection = ({ headerLabel, deviceOffers }: PepOffersSectionProps) => {
  return (
    <div data-testid="pep-offers-section">
      {headerLabel && (
        <>
          <Typography block heading="h2" variant={{ size: 'h3', color: 'brand' }}>
            {headerLabel}
          </Typography>
          <Spacer space={3} />
        </>
      )}
      {deviceOffers}
    </div>
  )
}

export default PepOffersSection
